var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("mdi-home")]),_c('label',{staticClass:"pl-4"},[_vm._v("Início")])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }